

export const featurePaths = {
    comapanylist: "/MstrCompany",
    locationlist: "/MstrLocation",
    departmentlist: "/MstrDepartment",
    chargecodelist: "/MstrChargeCode",
    showprefixslist: "/MstrShowPrefix",
    transportcodelist: "/MstrTransportCode",
    vattaxlist: "/MstrVatTax",
    organizerList: "/OrganizerList",
    venueList: "/MstrVenue",
    dsvofficeList: "/MstrDSVOffice",
    
} as const;

export const apiPaths = {
 
} as const;